module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_s.da4b21ac.png";